import PropTypes from 'prop-types';
import React, { useState } from 'react';

const AccountingDetailsAccordion = ({ tableData, title }) => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const handleAccordionToggle = idx => {
    setOpenAccordion(openAccordion === idx ? null : idx);
  };

  return (
    <div className="md:hidden px-2 py-4">
      <h2 className="text-lg font-bold text-primary-500 mb-4 text-center">{title}</h2>
      {tableData.length === 0 ? (
        <div className="text-center text-gray-500">No hay detalles disponibles.</div>
      ) : (
        tableData.map((row, idx) => {
          const key = row.description ? `row-${row.description}-${idx}` : `row-${idx}`;
          return (
            <div key={key} className="mb-4 border rounded-lg bg-white shadow">
              <button
                className="w-full flex flex-row items-center px-4 py-3 focus:outline-none gap-2"
                onClick={() => handleAccordionToggle(idx)}
              >
                <div className="flex flex-1 font-semibold text-primary-500 text-left items-center justify-between">
                  <span>{row.category || row.date}</span>
                </div>
                <div className="flex items-center justify-center" style={{ width: '32px', height: '32px' }}>
                  <svg
                    className="w-4 h-4 transition-transform duration-200"
                    style={{ transform: openAccordion === idx ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    fill="none"
                    stroke="#253858"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              {openAccordion === idx && (
                <div className="px-4 pb-4 pt-2 text-sm text-gray-700 border-t">
                  {row.date && (
                    <div className="mb-2 flex justify-between">
                      <span className="font-medium">Fecha:</span>
                      <span>{row.date}</span>
                    </div>
                  )}
                  {row.category && (
                    <div className="mb-2 flex justify-between">
                      <span className="font-medium">Categoría:</span>
                      <span>{row.category}</span>
                    </div>
                  )}
                  {row.description && (
                    <div className="mb-2 flex justify-between">
                      <span className="font-medium">Descripción:</span>
                      <span>{row.description}</span>
                    </div>
                  )}
                  {row.paymentType && (
                    <div className="mb-2 flex justify-between">
                      <span className="font-medium">Tipo de Pago:</span>
                      <span>{row.paymentType}</span>
                    </div>
                  )}
                  {row.total && (
                    <div className="mb-2 flex justify-between">
                      <span className="font-medium">Total:</span>
                      <span>{row.total}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

AccountingDetailsAccordion.propTypes = {
  tableData: PropTypes.array.isRequired,
  title: PropTypes.string
};

export default AccountingDetailsAccordion;
